import { useRouter } from 'next/dist/client/router';
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  get_orders,
  store_orderSelector,
} from '../../store/feature/store_orderSlice';
import NoOrdersItem from '../../components/MyStore/orders/NoOrdersItem/NoOrdersItem';
import OrdersFilter from '../../components/MyStore/orders/OrdersFilter/OrdersFilter';
import OrdersItem from '../../components/MyStore/orders/OrdersItem/OrdersItem';
import {
  filter_id,
  filter_name,
} from '../../components/Shared/Constant/Status';
import CustomLoading from '../../components/Shared/Loading/CustomLoading';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
import { Orders_text } from '../../constant/Translation/OrdersText';
import OrdersCalenderView from '../../components/MyStore/OrderDetails/Calender/CalenderView';
import {
  calender_icon,
  calender_icon2,
  list_icon,
} from '../../components/Shared/Constant/Icons/AllIcons';
import OrdersPageHeader from '../../components/MyStore/orders/OrdersPageHeader';
import Cookies from 'js-cookie';
import Pagination from '../../components/Shared/Pagination/Pagination';

const StoreOrdersPageLayout = () => {
  const [isShowCalender, setIsShowCalender] = useState(false);

  const [pageCount, setPageCount] = useState(0);

  const dispatch = useDispatch();
  const router = useRouter();
  const accountId =
    router.query.account_id ??
    Cookies.get(`${TYPE_CONSTANT.DOMAIN}_storeAccountID`);

  useEffect(() => {
    if (router.query.order_status) {
      dispatch(
        get_orders({
          bodyParam: {
            page: router.query?.page ? router.query?.page : 1,
            per_page: 30,
            account_id: accountId,
            order_status: filter_id(router.query.order_status),
          },
        })
      );
    } else {
      dispatch(
        get_orders({
          bodyParam: {
            page: router.query?.page ? router.query?.page : 1,
            per_page: 30,
            account_id: accountId,
          },
        })
      );
    }
  }, [router.query]);

  const { orders, total_records, page, isFetching } =
    useSelector(store_orderSelector);

  useEffect(() => {
    const totalpage = Math.ceil(total_records / 30);
    if (page === 1 && total_records === 0) {
      setPageCount(total_records);
    }
    if (Number(total_records) > 30) {
      setPageCount(totalpage);
    }
  }, [total_records]);

  const moreOrders = (next_page) => {
    if (router.query.order_status) {
      router.push({
        query: {
          account_id: accountId,
          page: next_page,
          order_status: filter_name(router.query.order_status),
        },
      });
    } else {
      router.push({
        query: {
          account_id: accountId,
          page: next_page,
        },
      });
    }
  };

  return (
    <div className=" mt-4">
      {isFetching && <CustomLoading />}
      <OrdersPageHeader
        isShowCalender={isShowCalender}
        setIsShowCalender={setIsShowCalender}
      />

      {/* Calender view */}
      {isShowCalender && <OrdersCalenderView orders={orders} />}

      {/* Normal View */}
      {!isShowCalender && (
        <>
          {orders === null || orders?.length > 0 ? (
            <div>
              <OrdersItem orders={orders} accountId={accountId} />
            </div>
          ) : (
            <div>
              <NoOrdersItem />
            </div>
          )}
          <div className="mt-12   flex justify-center pb-12 ">
            {orders !== null && (
              <Pagination
                moreData={moreOrders}
                pageCount={pageCount}
                current_page={page}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default StoreOrdersPageLayout;
